export default "__VITE_ASSET__Dzg2fMMv__"